var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"GetCollCategoryList":_vm.GetCollCategoryList,"GetfollowGoodsList":_vm.GetfollowGoodsList,"AddShopCart":_vm.AddShopCart,"DelCollection":_vm.DelCollection,"BatchAddShopCart":_vm.BatchAddShopCart}})}
var staticRenderFns = []

export { render, staticRenderFns }